import { render, staticRenderFns } from "./CreateUsage.vue?vue&type=template&id=066563b3&scoped=true&"
import script from "./CreateUsage.vue?vue&type=script&lang=js&"
export * from "./CreateUsage.vue?vue&type=script&lang=js&"
import style0 from "./CreateUsage.vue?vue&type=style&index=0&id=066563b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066563b3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksUsageRecordDetails: require('/opt/buildhome/repo/components/blocks/UsageRecordDetails.vue').default,BlocksUsageChangeSummary: require('/opt/buildhome/repo/components/blocks/UsageChangeSummary.vue').default,FormEdgeConfig: require('/opt/buildhome/repo/components/form/EdgeConfig.vue').default})
